<template>
  <main>
    <v-toolbar style="background-color: #444; color: #fff; border-radius: 5px">
      <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
    </v-toolbar>

    <v-form @submit.prevent="handleSubmit">
      <formWrapper :validator="$v.form">
        <v-container>
          <v-row>
            <v-col cols="12">
              <locale-select
                v-if="isEdit"
                v-model="locale"
                @change="changeLocale"
              />
            </v-col>

            <v-col cols="12">
              <first-step
                :tourismCities="tourismCities"
                :car_classifications="car_classifications"
                :isEdit="isEdit"
                :form="form"
              />
            </v-col>

            <v-col cols="12">
              <v-btn
                :disabled="$v.form.$invalid"
                :loading="loadingButton"
                type="submit"
                class="primary"
                large
                block
                rounded
                >{{ $t("button.save") }}
                <v-icon>mdi-content-save</v-icon></v-btn
              >
            </v-col>
            <!-- :disabled="$v.form.$invalid" -->
          </v-row>
        </v-container>
      </formWrapper>
    </v-form>
  </main>
</template>

<script>
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import {
  IndexData,
  StoreData,
  ShowData,
  UpdateData
} from "@/helpers/apiMethods";

export default {
  name: "CreateAndEditTrip",
  components: {
    FirstStep: () => import("./first_step")
  },
  provide() {
    return {
      $v: this.$v
    };
  },
  data() {
    return {
      loadingButton: false,
      locale: this.locale,
      form: {
        tourism_city: "",
        car_classification: "",
        duration_in_hours: "",
        max_allowed_km: "",
        cancel_before_start_in_hours: "",
        reserve_before_start_in_hours: "",
        price: "",
        return_pct: "",
        auto_accept_order: "0",
        visible: 1
      },

      tourismCities: [],
      car_classifications: []
    };
  },
  computed: {
    formTitle() {
      if (this.$route.name === "create-car-rent") {
        return this.$t("heading.create");
      } else {
        return this.$t("heading.edit");
      }
    },
    isEdit() {
      if (this.$route.name === "create-car-rent") {
        return false;
      } else {
        return true;
      }
    }
  },
  mounted() {
    this.getTourismCities();
    this.getCarClassifications();
  },
  methods: {
    resetData() {
      this.form.price = "";
      this.form.max_allowed_km = "";
      this.form.duration_in_hours = "";
      this.$v.form.$reset();
    },
    onFileChange({ file }) {
      this.form.main_media = file;
    },
    async getTourismCities() {
      const res = await IndexData({
        reqName: "tourism-cities",
        query: { pagination: "all" }
      });
      const { tourism_cities } = res.data;
      this.tourismCities = tourism_cities;
    },

    async getCarClassifications() {
      const res = await IndexData({
        reqName: "car-classifications",
        query: { pagination: "all" }
      });
      const { car_classifications } = res.data;
      this.car_classifications = car_classifications;
    },

    handleShowData(locale = this.locale) {
      ShowData({
        reqName: "car-rents",
        param: this.$route.params.slug,
        locale
      }).then(res => {
        const { car_rent } = res.data;
        this.form = {
          ...car_rent,
          car_classification: car_rent.car_classification.id,
          visible: car_rent.visible ? 1 : 0,
          auto_accept_order: car_rent.auto_accept_order ? 1 : 0
        };
      });
    },
    generateData() {
      const formData = new FormData();

      for (const key in this.form) {
        if (this.form[key] !== null && this.form[key] !== "null") {
          formData.append(key, this.form[key]);
        }
      }

      if (this.isEdit) {
        formData.append("_method", "put");
        formData.append("locale", this.locale);
      }
      return formData;
    },
    onCreate() {
      StoreData({ reqName: "car-rents", data: this.generateData() })
        .then(() => {
          this.resetData();
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
    onUpdate() {
      UpdateData({
        reqName: "car-rents",
        data: this.generateData(),
        param: this.$route.params.slug,
        locale: this.locale
      })
        .then(() => {
          this.$router.push("/car/rents");
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
    handleSubmit() {
      this.loadingButton = true;

      if (!this.isEdit) {
        // in case create
        this.onCreate();
      } else {
        // in case edit
        this.onUpdate();
      }
    },
    changeLocale(locale) {
      this.locale = locale;
      this.handleShowData(locale);
    },

    handleMultiPhotos(files) {
      if (!this.media) {
        this.media = [];
      }
      this.media = [...this.media, ...files];
    },
    onDeleteImage(index) {
      this.media.splice(index);
    }
  },
  validations: {
    form: {
      tourism_city: {
        required
      },
      car_classification: {
        required
      },
      duration_in_hours: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(24)
      },
      max_allowed_km: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(500)
      },
      cancel_before_start_in_hours: {
        required,
        minValue: minValue(0),
        maxValue: maxValue(336)
      },
      reserve_before_start_in_hours: {
        required,
        minValue: minValue(0),
        maxValue: maxValue(336)
      },
      price: {
        required,
        minValue: minValue(0),
        maxValue: maxValue(50000)
      },
      return_pct: {
        minValue: minValue(0),
        maxValue: maxValue(100)
      }
    }
  },

  watch: {
    isEdit: {
      handler(value) {
        if (value) {
          this.handleShowData();
        }
      },
      immediate: true
    },
    $route: {
      handler({ query }) {
        if (query["tourism_city"]) {
          this.form.tourism_city = Number(query["tourism_city"]);
        }
        if (query["car_classification"]) {
          this.form.car_classification = Number(query["car_classification"]);
        }
      },
      immediate: true
    }
  }
};
</script>
